import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { ArrowRight } from 'lucide-react';
export function Registration() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mldpdorl');
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    company: '',
    email: '',
    phone: '',
    smsConsent: false
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  // If form is successfully submitted
  if (state.succeeded) {
    return <section id="register" className="py-24 bg-[#FFF8DC]" data-id="element-145">
        <div className="container mx-auto px-4 md:px-6" data-id="element-146">
          <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden border border-[#D2691E]" data-id="element-147">
            <div className="bg-[#2F1B10] p-8 text-center" data-id="element-148">
              <h2 className="text-3xl font-bold text-white font-serif" data-id="element-149">
                Registration Received
              </h2>
            </div>
            <div className="p-12 text-center" data-id="element-150">
              <div className="mb-6 text-[#556B2F] flex justify-center" data-id="element-151">
                <div className="w-20 h-20 bg-[#556B2F] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-152">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-153">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-154" />
                  </svg>
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-4 text-[#2F1B10]" data-id="element-155">
                Yeehaw! We got your details.
              </h3>
              <p className="text-lg text-[#556B2F] mb-8" data-id="element-156">
                Complete your registration by securing your ticket below.
              </p>

              <a href="https://buy.stripe.com/3cIcN63e84oWgvrazF4Ni02" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold text-lg px-10 py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 transform hover:-translate-y-0.5" data-id="element-157">
                Pay $650 — Secure Your Seat
                <ArrowRight size={20} data-id="element-158" />
              </a>

              <p className="text-sm text-[#556B2F] mt-4 opacity-70" data-id="element-159">
                You'll be redirected to our secure payment page
              </p>

              <div className="mt-8 pt-6 border-t border-[#E5E5E5]" data-id="element-160">
                <button onClick={() => window.location.reload()} className="text-[#D2691E] font-bold hover:underline text-sm" data-id="element-161">
                  Return to homepage
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>;
  }
  return <section id="register" className="py-24 bg-[#FFF8DC] relative" data-id="element-162">
      <div className="container mx-auto px-4 md:px-6" data-id="element-163">
        <div className="max-w-5xl mx-auto" data-id="element-164">
          <div className="text-center mb-16" data-id="element-165">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2F1B10] font-serif mb-4" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-166">
              Reserve Your Seat
            </h2>
            <div className="w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-167"></div>
            <p className="mt-6 text-xl text-[#556B2F] max-w-2xl mx-auto" data-id="element-168">
              Space is strictly limited to 50 attendees. Secure your spot at the
              table.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#D2691E]" data-id="element-169">
            <div className="grid grid-cols-1 md:grid-cols-5" data-id="element-170">
              <div className="md:col-span-2 bg-[#2F1B10] p-10 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-171">
                <div className="absolute inset-0 opacity-20" style={{
                backgroundImage: 'url("https://www.transparenttextures.com/patterns/wood-pattern.png")'
              }} data-id="element-172"></div>
                <div className="relative z-10" data-id="element-173">
                  <h3 className="text-2xl font-bold font-serif mb-6 text-[#F4A460]" data-id="element-174">
                    What's Included
                  </h3>
                  <ul className="space-y-4" data-id="element-175">
                    <li className="flex items-start gap-3" data-id="element-176">
                      <span className="text-[#D2691E] mt-1" data-id="element-177">✓</span>
                      <span className="text-gray-300" data-id="element-178">
                        Full day of workshops & sessions
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-179">
                      <span className="text-[#D2691E] mt-1" data-id="element-180">✓</span>
                      <span className="text-gray-300" data-id="element-181">
                        Breakfast, Lunch & Snacks
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-182">
                      <span className="text-[#D2691E] mt-1" data-id="element-183">✓</span>
                      <span className="text-gray-300" data-id="element-184">
                        Private Dinner at Franklin BBQ
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-185">
                      <span className="text-[#D2691E] mt-1" data-id="element-186">✓</span>
                      <span className="text-gray-300" data-id="element-187">
                        Networking with 50+ CFOs
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="mt-12 relative z-10" data-id="element-188">
                  <p className="text-sm text-[#F4A460] uppercase tracking-widest mb-2" data-id="element-189">
                    Ticket Price
                  </p>
                  <p className="text-4xl font-bold font-serif" data-id="element-190">$650</p>
                  <p className="text-sm text-gray-400 mt-2" data-id="element-191">Per person</p>
                </div>
              </div>

              <div className="md:col-span-3 p-10" data-id="element-192">
                <form onSubmit={handleSubmit} data-id="element-193">
                  <div className="space-y-6" data-id="element-194">
                    <div data-id="element-195">
                      <label htmlFor="name" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-196">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="John Wayne" data-id="element-197" />
                      <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-198" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-199">
                      <div data-id="element-200">
                        <label htmlFor="title" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-201">
                          Job Title
                        </label>
                        <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="CFO" data-id="element-202" />
                        <ValidationError prefix="Job Title" field="title" errors={state.errors} data-id="element-203" />
                      </div>
                      <div data-id="element-204">
                        <label htmlFor="company" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-205">
                          Company
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="Acme Corp" data-id="element-206" />
                        <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-207" />
                      </div>
                    </div>

                    <div data-id="element-208">
                      <label htmlFor="email" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-209">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="john@example.com" data-id="element-210" />
                      <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-211" />
                    </div>

                    <div data-id="element-212">
                      <label htmlFor="phone" className="block text-sm font-bold text-[#2F1B10] mb-2 uppercase tracking-wide" data-id="element-213">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border-2 border-[#E5E5E5] rounded-lg focus:border-[#D2691E] focus:ring-0 outline-none transition-colors bg-[#FAFAFA]" placeholder="(512) 555-0123" data-id="element-214" />
                      <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-215" />
                    </div>

                    <div className="flex items-start gap-3" data-id="element-216">
                      <input type="checkbox" id="smsConsent" name="smsConsent" checked={formData.smsConsent} onChange={handleChange} className="mt-1 w-5 h-5 rounded border-2 border-[#D2691E] text-[#D2691E] focus:ring-[#D2691E] focus:ring-offset-0 cursor-pointer" data-id="element-217" />
                      <label htmlFor="smsConsent" className="text-sm text-[#556B2F] cursor-pointer" data-id="element-218">
                        I authorize Commerce CFO Roundtable to send me SMS text
                        messages about event updates, reminders, and related
                        information. Message and data rates may apply. Reply
                        STOP to unsubscribe.
                      </label>
                    </div>
                  </div>

                  <div className="mt-8" data-id="element-219">
                    <button type="submit" disabled={state.submitting} className="w-full flex items-center justify-center gap-2 bg-[#D2691E] hover:bg-[#A0522D] text-white font-bold py-4 rounded-lg transition-all shadow-lg hover:shadow-[#D2691E]/30 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-220">
                      {state.submitting ? 'Submitting...' : 'Submit Registration'}
                      {!state.submitting && <ArrowRight size={20} data-id="element-221" />}
                    </button>
                  </div>
                  <ValidationError errors={state.errors} data-id="element-222" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}